import { apiClient } from '../http'

/**
 * Сервис для работы с битвами
 */
export const battleService = {
    async getBetConfig() {
        const response = await apiClient.get('/battle/bet-config')
        return response.data
    },

    async createOrJoinBattle(betAmount) {
        const response = await apiClient.post('/battle/create', { betAmount })
        return response.data
    },

    /**
     * Получение текущей активной битвы
     */
    async getCurrentBattle() {
        const response = await apiClient.get('/battle/current')
        return response.data
    },

    /**
     * Получение истории битв
     */
    async getBattleHistory(params = {}) {
        const response = await apiClient.get('/battle/history', { params })
        return response.data
    },

    /**
     * Отмена ожидающей битвы
     */
    async cancelBattle(battleId) {
        const response = await apiClient.post(`/battle/${battleId}/cancel`)
        return response.data
    },
}
